import { Dialog, DialogContent, DialogContentText, LinearProgress } from '@mui/material';

export default function DialogSync({ open }) {
    return (
        <Dialog open={open}>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <DialogContentText sx={{ mb: 2 }}>
                    {"Sincronizando suas análises. Aguarde..."}
                </DialogContentText>
                <LinearProgress sx={{ width: '100%' }} />
            </DialogContent>
        </Dialog>
    );
}